import { ASSETS_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

const BASE_URL = `${ASSETS_BASE_URL}/lottie`;
/**
 * Define new animations uploaded to R2 here.
 */
export const LottieJSONs = {
  confettiWideLarge: `${BASE_URL}/confetti-wide-large.json`,
  confettiSuccess: `${BASE_URL}/confetti-success.json`,
  confettiSwirl: `${BASE_URL}/confetti-swirl.json`,
  followUpMessage: `${BASE_URL}/follow-up-message.json`,
  instagramLogo: `${BASE_URL}/instagram-logo.json`,
  emailSent: `${BASE_URL}/email-sent.json`,
  onboardingBudgetChartIn: `${BASE_URL}/onboarding/budget-chart-in.json`,
  onboardingBudgetChartOut: `${BASE_URL}/onboarding/budget-chart-out.json`,
  onboardingChecklistSlideIn: `${BASE_URL}/onboarding/checklist-slide-in.json`,
  onboardingChecklistSlideOut: `${BASE_URL}/onboarding/checklist-slide-out.json`,
} as const;
